@if (toggle) {
  <article class="modal__container">
    <section id="backdrop"></section>
    <section class="modal">
      <section class="modal__top">
        <h2 class="text--lg text--semibold gray-900">Compte rendu</h2>
      </section>
      <form (ngSubmit)="onSubmit()">
        <section class="input--row--w100">
          <label class="text--sm text--medium gray-600">A propos de votre dernière bilat</label>
          <section class="input--container">
            <textarea
              name="comment"
              class="input--text"
              [formControl]="commentControl"
              rows="5"
              placeholder="Saisir votre compte rendu..."
            ></textarea>
          </section>
        </section>
        <section class="input--row--w100 input--row--submit">
          <button [disabled]="commentControl.invalid" class="btn btn--primary btn--sm">Envoyer</button>
        </section>
      </form>
    </section>
  </article>
}
